import React from "react";

/**
 * Otomatik yenilemenin görünür karşılığı.
 *
 * Bilinçli olarak sessiz bir gösterge: 45 saniyede bir toast atmak ya da ekranı
 * yanıp söndürmek okumayı böler. Yenileme sürerken ikon döner, bittiğinde saat
 * güncellenir — kullanıcı verinin ne kadar taze olduğunu bakınca anlar.
 *
 * @param {boolean} refreshing      Yenileme sürüyor mu
 * @param {Date|null} lastRefreshedAt Son başarılı yenileme zamanı
 * @param {Function} [onClick]      Elle yenileme (verilirse gösterge tıklanabilir olur)
 * @param {string} [className]
 */
const RefreshIndicator = ({ refreshing, lastRefreshedAt, onClick, className = "" }) => {
    const time = lastRefreshedAt
        ? lastRefreshedAt.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })
        : null;

    const content = (
        <>
            <i
                className={`bx bx-refresh ${refreshing ? "bx-spin" : ""}`}
                style={{ fontSize: "1rem" }}
                aria-hidden="true"
            />
            <span>{refreshing ? "Yenileniyor…" : time ? `Son güncelleme ${time}` : "Otomatik yenileniyor"}</span>
        </>
    );

    const base = `d-inline-flex align-items-center gap-1 text-muted ${className}`.trim();
    const style = { fontSize: ".76rem", whiteSpace: "nowrap" };

    if (!onClick) return <span className={base} style={style}>{content}</span>;

    return (
        <button
            type="button"
            className={`btn btn-link p-0 ${base}`}
            style={{ ...style, textDecoration: "none" }}
            onClick={onClick}
            disabled={refreshing}
            title="Şimdi yenile"
        >
            {content}
        </button>
    );
};

export default RefreshIndicator;
